export const CARD_CLICKED = Symbol('card_clicked');